import { type DietaryPropertyKind } from '@sg/graphql-schema';

// ─────────────────────────────────────────────────────────────────────────────

export type Event =
  | { type: 'START' }
  | { type: 'TOGGLE_RESTRICTION'; value: DietaryPropertyKind }
  | { type: 'CANCEL' }
  | { type: 'CONFIRM' }
  | { type: 'RESET' };
